// rafce
import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './containers/Home';
import { fetchUser } from './utils/fetchUser';
// rr-dom deprecated Switch and remodelled it into Routes

const App = () => {
	const navigate = useNavigate();

	// useEffect happens only at the start (hence, no input [])
	useEffect(() => {
		const user = fetchUser();

		if (!user) {
			navigate('/login');
		}
	}, []);

	return (
		<Routes>
			<Route path="login" element={<Login />} />
			<Route path="/*" element={<Home />} />
		</Routes>
	);
};

export default App;
